/*
 * Bajas del padrón que la sincronización con el SGC dejó sin aplicar.
 *
 * Con una caída anómala de personas activas (MAX_CAIDA_ACTIVOS en
 * functions/productoresSync.js) la sincronización aplica altas y cambios pero saltea
 * las bajas: cada doc de `productores` / `comercialesClientes` que habría quedado
 * inactivo se marca con `bajaOmitida: { motivo, detectadaEn }` y conserva su acceso.
 * El panel Productores las muestra para que el personal interno las confirme.
 */

const toMillis = (ts) => {
    if (!ts) return 0;
    if (typeof ts.toMillis === 'function') return ts.toMillis();
    const date = ts instanceof Date ? ts : new Date(ts);
    return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

const emailsConBajaOmitida = (docs) => (docs || [])
    .filter((d) => d && d.bajaOmitida)
    .map((d) => d.email || d.id)
    .sort();

/**
 * Resumen de las bajas pendientes de confirmar en los dos padrones, o null si no hay.
 * El motivo y la fecha son los de la marca más reciente.
 */
export const resumirBajasOmitidas = (productores = [], comerciales = []) => {
    const marcadas = [...(productores || []), ...(comerciales || [])].filter((d) => d && d.bajaOmitida);
    if (marcadas.length === 0) return null;
    const masReciente = marcadas.reduce((a, b) => (
        toMillis(b.bajaOmitida.detectadaEn) > toMillis(a.bajaOmitida.detectadaEn) ? b : a
    ));
    return {
        productores: emailsConBajaOmitida(productores),
        comerciales: emailsConBajaOmitida(comerciales),
        total: marcadas.length,
        motivo: masReciente.bajaOmitida.motivo || '',
        detectadaEn: masReciente.bajaOmitida.detectadaEn || null,
    };
};

const listar = (bajas) => {
    const partes = [];
    if (bajas.productores?.length) partes.push(`productores: ${bajas.productores.join(', ')}`);
    if (bajas.comerciales?.length) partes.push(`comerciales: ${bajas.comerciales.join(', ')}`);
    return partes.join('; ');
};

/**
 * Texto del aviso cuando una sincronización manual devuelve `bajasOmitidas`
 * (o el panel encuentra marcas de una corrida programada).
 */
export const describirBajasOmitidas = (bajas) => {
    if (!bajas) return '';
    const total = (bajas.productores?.length || 0) + (bajas.comerciales?.length || 0);
    const motivo = bajas.motivo ? `${bajas.motivo} ` : '';
    return `${motivo}Se aplicaron las altas y los cambios, pero no se dio de baja a ${total} persona(s) `
        + `(${listar(bajas)}): siguen con acceso hasta que se confirme.`;
};
